import React, { useEffect, useState } from "react";

export const GlobalDragOverlay = ({ children, onGlobalDrop }) => {
  const [isDraggingOverDocument, setIsDraggingOverDocument] = useState(false);

  useEffect(() => {
    const handleDragEnter = (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (e.dataTransfer.types.includes("Files")) {
        setIsDraggingOverDocument(true);
      }
    };

    const handleDragLeave = (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (e.relatedTarget === null) {
        setIsDraggingOverDocument(false);
      }
    };

    const handleDragOver = (e) => e.preventDefault();
    const handleDrop = (e) => {
      e.preventDefault();
      setIsDraggingOverDocument(false);
      if (onGlobalDrop) onGlobalDrop(e);
    };

    document.addEventListener("dragenter", handleDragEnter);
    document.addEventListener("dragleave", handleDragLeave);
    document.addEventListener("dragover", handleDragOver);
    document.addEventListener("drop", handleDrop);

    return () => {
      document.removeEventListener("dragenter", handleDragEnter);
      document.removeEventListener("dragleave", handleDragLeave);
      document.removeEventListener("dragover", handleDragOver);
      document.removeEventListener("drop", handleDrop);
    };
  }, [onGlobalDrop]);

  return (
    <>
      {isDraggingOverDocument && (
        <div
          className="fixed inset-0 bg-black/50 backdrop-blur-md z-50 flex items-center justify-center"
          onDrop={(e) => e.preventDefault()}
        >
          <div className="relative inset-0 w-[80vw] z-50 flex items-center gap-5 justify-center flex-col h-[80vh] border-[1px] border-dashed border-white">
            <div className="absolute -top-[2.5px] -left-[2.5px] w-24 h-24 border-t-[5px] border-l-[5px] border-white"></div>
            <div className="absolute -top-[2.5px] -right-[2px] w-24 h-24 border-t-[5px] border-r-[5px] border-white"></div>
            <div className="absolute -bottom-[2.5px] -left-[2.5px] w-24 h-24 border-b-[5px] border-l-[5px] border-white"></div>
            <div className="absolute -bottom-[2.5px] -right-[2.5px] w-24 h-24 border-b-[5px] border-r-[5px] border-white"></div>
            <div className="w-[7vw] h-[13vh] mt-2">
              <img
                src="https://cdn-icons-png.flaticon.com/512/390/390901.png"
                alt=""
                className="w-full h-full"
              />
            </div>
            <p className="text-4xl font-bold text-[#ffffffa9] drop-shadow-lg">
              Drop Anywhere
            </p>
          </div>
        </div>
      )}
      {children}
    </>
  );
};